import React, { useEffect, useState } from "react";
import axios from "axios";

const ChartContainer = () => {
  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse(localStorage.getItem("apiPaths")) : "-"

  const [funnelData, setFunnelData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFunnelData();
  }, []);

  const fetchFunnelData = async () => {
    try {
      const response = await axios.get(
        `${apiPaths_from_local_storage[0].API_CONFIG}/api/HRDashboard/${company_code_from_local_storage}/MAIN/CRM_salesfunnel/2024-01-01/2025-03-30/-/-/-/-/-`
      );
      const data = response.data;

      console.log("Funnel Response Data:", data);

      const mappedData = data
        .map((item) => {
          let fillColor;

          // Assign specific colors based on the label
          if (item.lead_CampaignId === "Qualified") {
            fillColor = "#4ADE80"; // Green for Qualified
          } else if (item.lead_CampaignId === "Prospect") {
            fillColor = "#FB923C"; // Orange for Prospect
          } else if (item.lead_CampaignId === "Closed Won") {
            fillColor = "#2563EB"; // Blue for Closed Won
          } else if (item.lead_CampaignId === "Negotiation") {
            fillColor = "#F87171"; // Red for Negotiation
          } else if (item.lead_CampaignId === "Closed Lost") {
            fillColor = "#DC2626"; // Red for Closed Lost
          } else {
            fillColor = "#7c7c7c"; // Default gray for other labels
          }

          return {
            label: `${item.lead_CampaignId} (${item?.lead_count})`,
            value: item?.lead_count,
            fill: fillColor,
          };
        })
        .sort((a, b) => b.value - a.value); // Sort by value in descending order

      setFunnelData(mappedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching funnel data", error);
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center px-2">
      <div className="w-full max-w-screen-md">
        <h2 className="p-2 text-center text-lg md:text-xl font-semibold mb-4">SALES FUNNEL</h2>
        {loading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : (
          <div className="flex flex-col items-center gap-2 p-2">
            {funnelData.map((item, index) => (
              <div
                key={index}
                className="flex items-center justify-center text-center"
                style={{
                  width: `${100 - index * 14}%`,
                  height: "48px",
                  backgroundColor: item.fill,
                  clipPath: "polygon(0% 0%, 100% 0%, 93% 100%, 6% 100%)",
                }}
              >
                <span className="text-white text-sm md:text-base font-semibold truncate px-2">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartContainer;